import { Box, FormControl, FormHelperText, Grid, InputLabel, OutlinedInput, OutlinedInputProps, TextField } from "@mui/material";
import { FocusEvent, FocusEventHandler, forwardRef, useState } from "react";

type Props = {
    labelName: string,
    type: string,
    inputProps?: Partial<OutlinedInputProps>,
    value?: any,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    placeholder?: string,
}

const AppInput = forwardRef<HTMLInputElement, Props>(({ labelName, type, inputProps, value, onChange, placeholder }, ref) => {
  const [error, setError] = useState(false)
  const [validationError, setvalidationError] = useState(false)
  const checkNull = (e: FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
    const inputValue = e.currentTarget.value
    if(!inputValue){
      setError(true)
    } else if(!(typeof inputValue === "string")){
      setError(false)
      setvalidationError(true)
    } else {
      setError(false)
      setvalidationError(false)
    }
  }

  return(
    <div>
      <Box display="flex" alignItems="center">
        <Grid item xs={6} textAlign="center">
          <InputLabel shrink style={{ fontSize: 20 }}>{labelName}</InputLabel>
        </Grid>
        <Grid item xs={6}>
          <OutlinedInput id="input" type={type} value={value} inputRef={ref} {...inputProps} onChange={onChange} style={{ margin: 8, width: 170 }} error={error} placeholder={placeholder} onBlur={checkNull} />
          {error && <FormHelperText sx={{color:"red"}}>！！必須項目です。</FormHelperText>}
          {validationError && <FormHelperText>文字列を入力してください。</FormHelperText>}
        </Grid>
      </Box>
    </div>
  )
})
export default AppInput;